// extracted by mini-css-extract-plugin
module.exports = {"kyc__background":"KYCform_kyc__background__19JOo","kyc__box":"KYCform_kyc__box__uDLfi"};